export const usePagination = ({ page, pageSize }) => {
  const start = (page - 1) * pageSize;
  const end = start + pageSize;

  return {
    end,
    start,
  };
};
